import React, { forwardRef, ComponentProps } from 'react';
import { TableExpandRow as CarbonTableExpandRow } from '@carbon/react';

export type TableExpandRowProps = ComponentProps<typeof CarbonTableExpandRow>;

export const TableExpandRow = forwardRef<
  HTMLTableCellElement,
  TableExpandRowProps
>((props, ref) => <CarbonTableExpandRow ref={ref} {...props} />);

TableExpandRow.displayName = 'TableExpandRow';
